import { initInfiniteHorizontalMarquee } from '../functions/infiniteHorizontalMarquee';

const rootSelector = '.js-finished_investments',
    trackSelector = '.js-finished_investments-wrapper',
    slideSelector = '.js-finished_investments-slide';

const AUTO_SCROLL_PX_S = window.matchMedia('(prefers-reduced-motion: reduce)').matches
    ? 0
    : 38;

/** Szerokość karty: węższa na mobile; od md większa. Wysokość rzędu = stretch na tracku. */
function getSpvAndGap(containerWidth) {
    return {
        slideWidthPx: containerWidth >= 768 ? 382 : 310,
        gap: containerWidth >= 768 ? 24 : 16,
    };
}

function initFinishedInvestments() {
    if (!document.querySelector(rootSelector)) {
        return;
    }

    initInfiniteHorizontalMarquee({
        containerSelector: rootSelector,
        trackSelector,
        slideSelector,
        getSpvAndGap,
        speedPxPerSecond: AUTO_SCROLL_PX_S,
        remeasureOnImageLoad: true,
    });
}

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initFinishedInvestments);
} else {
    initFinishedInvestments();
}
